export const defaultTextSize = {
    "--text-xs": 0.75,
    "--text-sm": 0.875,
    "--text-base": 1,
    "--text-lg": 1.125,
    "--text-xl": 1.25,
    "--text-2xl": 1.5,
    "--text-3xl": 1.875,
    "--text-4xl": 2.25,
    "--text-5xl": 3,
}

export const defaultAddTextStep = 0.25
